import { Box, Collapse, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { HEADER_DATA_UPDATE } from "../../../redux/reducers/header.reducer";
import { TurnosFiltro } from "./TurnosFiltro";
import { GetMovimientosByAlmacenTurno } from "../../../hooks/reporteTurnos";
import array_first_seen from "../../../helpers/arrayFirstSeen";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { ThemeContext } from "@emotion/react";
import { GetProcesadosReporteTurno } from "../../../hooks/reportesTurno";
import { useLoading } from "../../../components/Loading/useLoading";

export const ReporteTurnoIndex = () => {

  const dispatch = useDispatch();
  const {setAppLoading} = useLoading();
  const theme = useContext(ThemeContext);
  const { getProcesadosReporteTurno } = GetProcesadosReporteTurno();
  const [movPros, setMovPros] = useState([]);

  useEffect(() => {
    dispatch(
      HEADER_DATA_UPDATE({ nombreData: null })
    )
  }, []);

  const get_movimientos = (almacen, turno, inicio, fin) => {
    setAppLoading(true)
    getProcesadosReporteTurno({ almacen, turno, inicio, fin }, {
      onSuccess: (data) => {
        console.log(data)
        setMovPros(data)
      },
      onError: (error) => {
        console.log(error)
      },
      onSettled: () => {
        setAppLoading(false)
      }
    })
  }

  function ThirdRow(props) {
    const { row } = props;
    const [open, setOpen] = useState(false);

    const open_subtabla = (index) => {
      if (open) {
        setOpen(!open);
      } else {
        setOpen(!open);
      }
    };

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell sx={{ p: 0.5 }}>
            <IconButton
              aria-label="expand row"
              size="small"
              style={{ width: 25 }}
              disabled={row?.movsDesgloce.length === 0}
              onClick={() => open_subtabla(row?.part_id)}
            >
              {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </TableCell>
          <TableCell align="center">
            {row?.fechaHora}
          </TableCell>
          <TableCell align="center">
            {row?.cantidad}
          </TableCell>
          <TableCell align="center">
            {row?.usu_id}
          </TableCell>
          <TableCell align="center">
            {row?.tipo}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  Desgloce por conjunto movimiento
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Serial
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Etiqueta
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Rack/Barril
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Estacion Recubrimiento
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Cantidad
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row?.movsDesgloce?.map((mov) => (
                      <TableRow key={mov?.moin_id}>
                        <TableCell align="center">
                          {mov?.moin_serial}
                        </TableCell>
                        <TableCell align="center">
                          {mov?.etiq_codigo}
                        </TableCell>
                        <TableCell align="center">
                          {mov?.rack}
                        </TableCell>
                        <TableCell align="center">
                          {mov?.estacion}
                        </TableCell>
                        <TableCell align="center">
                          {mov?.moin_cantidad}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  function SecondRow(props) {
    const { row } = props;
    const [open, setOpen] = useState(false);

    const open_subtabla = (index) => {
      if (open) {
        setOpen(!open);
      } else {
        setOpen(!open);
      }
    };

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell sx={{ p: 0.5 }}>
            <IconButton
              aria-label="expand row"
              size="small"
              style={{ width: 25 }}
              onClick={() => open_subtabla(row?.part_id)}
            >
              {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row.part_nombre}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row.part_codigoentrada}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row.part_codigosalida}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row.empresa}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row.cantidad}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row.cantidadCargas}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  Desgloce por conjunto procesado
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" sx={{ color: "white" }} />
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Fecha y hora
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Cantidad
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Usuario responsable
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Tipo
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row?.cargasDesgloce?.map((thirdRow, index) => (
                      <ThirdRow key={index} row={thirdRow} />
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = useState(false);

    const open_subtabla = (index) => {
      if (open) {
        setOpen(!open);
      } else {
        setOpen(!open);
      }
    };

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell sx={{ p: 0.5 }}>
            <IconButton
              aria-label="expand row"
              size="small"
              style={{ width: 25 }}
              onClick={() => open_subtabla(row?.part_id)}
            >
              {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row.fecha}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row.turno}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row.tiempoDelTurno}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row.cargas}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  Desgloce por parte
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" />
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Parte
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Código entrada
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Código Salida
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Cliente
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Cantidad total
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Cargas
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row?.movsNoDesgloce?.map((secRow, index) => (
                      <SecondRow key={index} row={secRow} />
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <Grid container spacing={0} sx={{ height: '87vh', alignContent: 'flex-start', overflowY: 'auto' }}>
      <Grid item xs={12} sx={{ padding: '10px 20px', flexDirection: 'column', justifyContent: 'flex-start' }} className="center_item">
        <TurnosFiltro key='filtros_r_turno' get_data={get_movimientos} canDownXlsx={movPros.length > 0}/>
      </Grid>
      <Grid item xs={12} sx={{ padding: '10px 20px', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start' }} className="center_item">
        {
          movPros.length > 0 &&
          <Paper
            style={{ maxHeight: '100vh', overflowY: "scroll", width: "100%" }}
            sx={{ boxShadow: "none" }}
          >
            {/* <Typography variant="h8" sx={{ fontWeight: 500 }} gutterBottom component="div">
              Procesados
            </Typography> */}
            <TableContainer component={Paper}>
              <Table aria-label="collapsible table">
                <TableHead
                  sx={{
                    display: "table-head",
                    backgroundColor: theme.palette.primary.main,
                    fontWeight: 600,
                  }}
                >
                  <TableRow>
                    <TableCell align="center" sx={{ color: "white" }} />
                    <TableCell align="center" sx={{ color: "white" }}>
                      Fecha
                    </TableCell>
                    <TableCell align="center" sx={{ color: "white" }}>
                      Turno
                    </TableCell>
                    <TableCell align="center" sx={{ color: "white" }}>
                      Total Horas
                    </TableCell>
                    <TableCell align="center" sx={{ color: "white" }}>
                      Cargas Totales
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {movPros?.map((row, index) => (
                    <Row key={index} row={row} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        }
      </Grid>
    </Grid>
  )
}